export default {
    "type": "string",
    "enum": [
        "1:1",
        "2:1",
        "4:3"
    ],
    "default" : "1:1"
}